import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { ItemWiseProcessPopup } from './ItemWiseProcessTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import DailyReportsServices from '../../../services/axiosServices/apiServices/DailyReportsServices';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class ItemWiseProcess extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.dailyReportsServices = new DailyReportsServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isTable2Expanded: false,
            rowData: [],
            colDefs: [],
            table2Data: [],
            table2ColDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            caption: "",
            idProcessItem: 0,
            isSelectItemPopUp: false,
            itemObject: {
                idProcessItem: 0,
                updateStatus: 0,
                srNo: "",
                selectCategoryId: 0,
                selectCategoryList: [],
                idItem: 0,
                ItemLabel: '',
                selectItemList: [],
                selectProcessId: 0,
                selectProcessList: [],
                itemList: [],
                processColdefs: [
                    {
                        field: "sequenceNo",
                        headerName: "Sr.No",
                        flex: 0.5,
                        filter: true,
                    },
                    {
                        field: "processDetails",
                        headerName: "Process Details",
                        flex: 2,
                        filter: true,
                    },
                ],
                eDate: "",
                sequenceNo: 0,
            },
            selectItemColDefs: [
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                selectCategoryId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item category name"
                        ),
                    },
                ],
                idItem: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item"
                        ),
                    },
                ],
            },
            validationRulesInsert: {
                selectProcessId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "process"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddEditItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
        });
    };

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idProcessItem, this.state.caption);
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getMasterProcessItemSelectbyID(event.data.idProcessItem);
        //this.getMasterExpenseAccountGroupSelectbyID(event.data.idAccountGroup);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    handleCellClickItemList = (event) => {
        let itemObject = this.state.itemObject;
        let list = itemObject.itemList[event.data.sequenceNo - 1];
        itemObject.sequenceNo = event.data.sequenceNo;
        itemObject.selectProcessId = event.data.idProcess;
        this.setState({ itemObject: itemObject });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFieldsInsert = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRulesInsert,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false });
    };

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let itemObject = this.state.itemObject;
        itemObject.processNo = "";
        itemObject.processName = "";
        itemObject.processDesc = "";
        itemObject.remarks = "";
        itemObject.selectProcessId = "";
        itemObject.sequenceNo = "";

        // itemObject.idProcessItem = 0;
        // itemObject.updateStatus = 0;
        // itemObject.srNo = "";
        // itemObject.selectCategoryId = 0;
        // itemObject.selectCategoryList = [];
        // itemObject.idItem = 0;
        // itemObject.ItemLabel = '';
        // //itemObject.selectItemList = [];
        // itemObject.selectProcessId = 0;
        // //itemObject.selectProcessList = [];
        // itemObject.itemList = [];
        // itemObject.eDate = "";
        // itemObject.sequenceNo = 0;

        this.setState({
            itemObject: itemObject, validState: validState
        }, () => {
            this.getCount();
        });
    }

    handleChangeFroDropdown = (event, name) => {
        //debugger;
        let details = this.state.itemObject;
        let value = event.value;
        details[name] = value;
        this.setState({ productObject: details }, () => {
            if (name === 'selectCategoryId') {
                this.getMasterItemSelectbyIDCategory(value)
            } else if (name === 'itemTypeId' || name === 'itemTypeId2') {
                this.getMaster_ItemSelectbyItemType(event.label, name);
            } else if (name === 'itemId2') {
                this.getMaster_ItemSelectbyID(value);
            }
        });
    }

    handleOnClick = (event, name) => {
        //debugger
        if (name === 'selectItemList') {
            this.setOpenModel2();
        }
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.itemObject;
        data.idItem = event.data.idItem;
        data.ItemLabel = event.data.itemName;
        this.setState({ itemObject: data, isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.getAllDropdownForStockMaster();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    getAllDropdownForStockMaster = () => {
        this.masterEntryServices.getAllDropdownForStockMaster(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.itemObject;
                data.selectCategoryList = allData.filter(item => item.source === 'Master_ItemCategoryForItemWiseProcess');
                data.selectProcessList = allData.filter(item => item.source === 'Master_Process');

                this.setState({
                    productObject: data
                }, () => {
                    //this.usp_Master_EmployeeSelect()
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    getCount = () => {
        // let request = {
        //     idCompany: this.state.idCompany,
        //     idFinancialYear: 0
        // };
        // this.accountTransactionServices.getTransaction_AddCashOrAdvanceCount(request).then((response) => {
        // if (response.statusCode == 200 && response.responseItem !== null) {
        let list = this.state.rowData;
        let maxIdPaymentMake = list.length > 0 ? list.length : 0;
        let receiptNo = String(maxIdPaymentMake + 1).padStart(3, '0');
        let data = this.state.itemObject;
        data.srNo = receiptNo;
        this.setState({
            itemObject: data
        });
        // }
        // });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Item wise Process",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idProcessItem"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs, //updatedColDefs,
                            caption: "Item wise Process",
                            colName: colName
                        }, () => {
                            this.procSelectAllRecord2GridviewSP(id, "Item wise Process");
                            //this.getAllDropdownForEmployeeMaster();
                            this.setPermissions(permissions);
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.05,
            "drawingNo": window.innerWidth * 0.2,
            "itemCategory": window.innerWidth * 0.2,
            "itemName": window.innerWidth * 0.3,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            //idCompany: this.state.prop.idCompany
        }
        this.dailyReportsServices.procSelectAllRecord2GridviewSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                const dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                        field: key,
                        headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                        flex: 1,
                        hide: ["sR.No"].includes(key) ? true : false,
                    }));
                    this.setState({
                        table2Data: dynamicData,
                        table2ColDefs: dynamicColDefs,
                        isTable2Expanded: true
                    });
                } else {
                    this.setState({
                        table2Data: [],
                        table2ColDefs: [],
                        isTable2Expanded: false,
                    });
                }
            }
        });
    }

    getMasterItemSelectbyIDCategory = (idItemCategory) => {
        let request = [idItemCategory, this.state.idCompany];
        this.masterEntryServices.getMasterItemSelectbyIDCategory(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = this.state.itemObject;
                // data = data.map((x) => ({
                //     value: x.idItem,
                //     label: x.itemName,
                // }));
                if (data.length > 0) {
                    itemObject.selectItemList = data;
                } else {
                    itemObject.selectItemList = [];
                }
                itemObject.idItem = 0;
                this.setState({
                    itemObject: itemObject
                });
            }
        });
    }

    insert = (isFor) => {
        const isValidAllFields = this.isValidAllFieldsInsert();
        if (isValidAllFields) {
            let itemObject = this.state.itemObject;
            let itemDataList = itemObject.itemList;
            let obt = {
                sequenceNo: 0,
                idProcess: itemObject.selectProcessId,
                processDetails: itemObject.selectProcessList?.find(x => x.value === itemObject.selectProcessId)?.label,
                currentStock: 0,
            }
            var findExistsOrNot = itemDataList.filter(item => item.idProcess == obt.idProcess && item.processDetails === obt.processDetails);
            if (findExistsOrNot.length > 0) {
                this.SwalServices.Warning("Same item already exist.");
            } else {
                itemDataList.push(obt);
                if (itemDataList.length > 0) {
                    itemDataList.map((x, srNo) => {
                        x.sequenceNo = srNo + 1;
                    });
                    itemObject.selectProcessId = 0;
                }
                itemObject.itemList = [...itemDataList];
                this.setState({ itemObject: itemObject })
            }

        }
    }

    Delete = (sequenceNo) => {
        let data = this.state.itemObject;
        let itemList = data.itemList.filter(item => item.sequenceNo !== sequenceNo);
        if (itemList.length > 0) {
            itemList.map((x, srNo) => {
                x.sequenceNo = srNo + 1;
            });
        }
        data.itemList = [...itemList];
        data.selectProcessId = 0;
        data.sequenceNo = 0;
        this.setState({ itemObject: data })
    }

    submit = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.itemObject;
            let requestData = {
                idProcessItem: details.idProcessItem,
                idProduct: details.idItem,
                idCompany: this.state.idCompany,
                idCompanyDivision: 0,
                e_Date: details.eDate && details.eDate !== 'Invalid date' ? details.eDate : new Date().toISOString(),
                isUpdated: details.updateStatus === 1 ? true : null,
                updatedDate: details.updateStatus === 1 ? new Date().toISOString() : null,
                isDeleted: false,
                deletedDate: null,
                itemList: details.itemList,
            };
            this.masterEntryServices.submitMasterProcessItem(requestData)
                .then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData !== null) {
                            if (dynamicData.errorType === 'Exists') {
                                this.SwalServices.Warning(dynamicData.errorMessage);
                            } else {
                                if (this.state.itemObject.updateStatus === 1) {
                                    this.SwalServices.Success("Updated successfully.");
                                } else {
                                    this.SwalServices.Success("Saved successfully.");
                                }
                                this.resetDetailsFields();
                                // Call resetFields here after submission
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.procSelectAllRecordsSP(); // Fetch latest records
                                    }
                                );
                            }
                        } else {
                            this.procSelectAllRecordsSP();
                        }
                    } else {
                        this.setState(
                            { isModalOpen: false },
                            () => {
                                this.SwalServices.Error(response.message);
                                this.procSelectAllRecordsSP(); // Fetch latest records
                            }
                        );
                    }
                });
        }
    };

    getMasterProcessItemSelectbyID = (id) => {
        if (id > 0) {
            this.masterEntryServices.getMasterProcessItemSelectbyID(id).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    let itemObject = this.state.itemObject;
                    itemObject.idProcessItem = res.idProcessItem;
                    itemObject.updateStatus = 1;
                    itemObject.srNo = res.idProcessItem;
                    itemObject.selectCategoryId = res.idItemCategory;
                    itemObject.idItem = res.idProduct;
                    this.setState({
                        itemObject: itemObject,
                        isModalOpen: true
                    });
                    let request = [res.idItemCategory, this.state.idCompany];
                    this.masterEntryServices.getMasterItemSelectbyIDCategory(request).then((response2) => {
                        if (response2.statusCode == 200 && response2.responseItem !== null) {
                            let data = response2.responseItem.responseContent;
                            let item = this.state.itemObject;
                            // data = data.map((x) => ({
                            //     value: x.idItem,
                            //     label: x.itemName,
                            // }));
                            if (data.length > 0) {
                                item.selectItemList = data;
                                item.idItem = res.idProduct;
                            } else {
                                item.selectItemList = [];
                                item.idItem = 0;
                            }
                            item.ItemLabel = item.idItem > 0 ? item.selectItemList?.find(x => x.idItem === item.idItem)?.itemName : '';
                            this.setState({
                                itemObject: item
                            });
                        }
                    });
                    this.masterEntryServices.getMasterProcessItemListSelectbyID(res.idProcessItem).then((response3) => {
                        if (response3.statusCode == 200 && response3.responseItem !== null) {
                            let data = response3.responseItem.responseContent;
                            let itemObject = this.state.itemObject;
                            let itemDataList = [];
                            data?.map((x, key) => {
                                let obt = {
                                    sequenceNo: key + 1,
                                    idProcess: x.idProcess,
                                    processDetails: x.process,
                                    currentStock: x.currentStock ? x.currentStock : 0,
                                }
                                itemDataList.push(obt);
                            })
                            itemObject.itemList = [...itemDataList];
                            this.setState({ itemObject: itemObject })
                        }
                    });
                }
            });
        }
    }

    render() {
        return (
            <>
                <div className='tax-structure-master'>
                    <div className='data-display'>
                        <div className='data-display-inner relative'>
                            <ButtonGrp buttons={['add', 'print', 'delete']}
                                onClickHandlers={{
                                    add: () => this.openPopUpForAddEditItem(),
                                    //update: () => this.openPopUpForAddEditItem("Edit"),
                                    print: this.handlePrint,
                                    delete: this.handleDelete,
                                }}
                            />
                            <ItemWiseProcessPopup
                                isModalOpen={this.state.isModalOpen}
                                setOpenModel={this.setOpenModel.bind(this)}
                                itemObject={this.state.itemObject}
                                handleChange={this.handleChange.bind(this)}
                                close={this.closePopup.bind(this)}
                                insert={this.insert.bind(this)}
                                Delete={this.Delete.bind(this)}
                                handleChangeFroDropdown={this.handleChangeFroDropdown.bind(this)}
                                submit={this.submit.bind(this)}
                                validState={this.state.validState}
                                handleCellClickItemList={this.handleCellClickItemList}
                                handleOnClick={this.handleOnClick.bind(this)}
                            />
                            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-1 h-[68vh] w-full px-[1px] rounded-[5px]">
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Item wise process</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.rowData}
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.colDefs}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onCellClicked={this.handleCellClick}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        onGridReady={this.onGridReady}
                                        overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                        overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    />
                                </div>
                            </div>

                            <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                    <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.table2Data}
                                        columnDefs={this.state.table2ColDefs}
                                        rowHeight={this.state.rowHeight}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onGridReady={this.onGridReady}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.itemObject.selectItemList}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    //handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />
            </>
        )
    }
}
